/**
 * Cores de gráfico — só tokens do :root.
 *
 * SVG aceita `var(--marca)` em fill. Antes cada relatório inventava um hex
 * (#c8972a, #276749, #1565c0…) e o mesmo lucro mudava de tom entre telas.
 */
export const CORES_GRAFICO = [
  'var(--marca)',
  'var(--accent)',
  'var(--info)',
  'var(--sucesso)',
  'var(--alerta)',
  'var(--danger)',
];

export const COR_RECEITA = 'var(--sucesso)';
export const COR_CUSTO = 'var(--danger)';

/** Cor de lucro/prejuízo. Sem valor, devolve undefined para o texto herdar. */
export const corSinal = (n) => {
  if (n == null || Number.isNaN(n)) return undefined;
  return n >= 0 ? 'var(--sucesso)' : 'var(--danger)';
};

export const classeSinal = (n) => {
  if (n == null || Number.isNaN(n)) return undefined;
  return n >= 0 ? 'valor-positivo' : 'valor-negativo';
};

/** Tom do KPI (`Metrica`) a partir do sinal do número. */
export const tomSinal = (n) => {
  if (n == null || Number.isNaN(n)) return undefined;
  return n >= 0 ? 'positivo' : 'negativo';
};
